import * as Schema from "effect/Schema";

import { IsoDateTime, OperatorProjectId, TrimmedNonEmptyString } from "./baseSchemas.ts";

export const WorkspaceMcpScope = Schema.Literals([
  "workspace:read",
  "logs:read",
  "tools:execute",
  "agent:execute",
  "workspace:manage",
]);
export type WorkspaceMcpScope = typeof WorkspaceMcpScope.Type;

/** Installer metadata is supplied by the signed-in settings client; it grants no workspace access. */
export const WorkspaceAgentSkillInstallInput = Schema.Struct({
  id: OperatorProjectId,
  name: TrimmedNonEmptyString.check(Schema.isMaxLength(1024)),
  operatorName: TrimmedNonEmptyString.check(Schema.isMaxLength(1024)),
  url: TrimmedNonEmptyString.check(Schema.isMaxLength(8192)),
});
export type WorkspaceAgentSkillInstallInput = typeof WorkspaceAgentSkillInstallInput.Type;

export const WorkspaceMcpConsentInput = Schema.Struct({
  action: Schema.Literals(["read", "approve", "deny"]),
  projectId: OperatorProjectId,
  flowId: TrimmedNonEmptyString,
});
export type WorkspaceMcpConsentInput = typeof WorkspaceMcpConsentInput.Type;

export const WorkspaceMcpConsentPreview = Schema.Struct({
  flowId: TrimmedNonEmptyString,
  projectId: OperatorProjectId,
  workspaceName: Schema.String,
  clientName: Schema.String,
  scopes: Schema.Array(WorkspaceMcpScope),
  resource: TrimmedNonEmptyString,
  expiresAt: IsoDateTime,
  canApprove: Schema.Boolean,
});
export type WorkspaceMcpConsentPreview = typeof WorkspaceMcpConsentPreview.Type;

export const WorkspaceMcpConsentResult = Schema.Struct({
  consent: Schema.optionalKey(WorkspaceMcpConsentPreview),
  redirectUrl: Schema.optionalKey(TrimmedNonEmptyString),
});
export type WorkspaceMcpConsentResult = typeof WorkspaceMcpConsentResult.Type;

export const WorkspaceMcpConnection = Schema.Struct({
  id: TrimmedNonEmptyString,
  projectId: OperatorProjectId,
  label: Schema.String.check(Schema.isMaxLength(128)),
  scopes: Schema.Array(WorkspaceMcpScope),
  expiresAt: IsoDateTime,
});
export type WorkspaceMcpConnection = typeof WorkspaceMcpConnection.Type;

/** The token is returned once on creation; listings never include it. */
export const WorkspaceMcpConnectionCreated = Schema.Struct({
  ...WorkspaceMcpConnection.fields,
  token: TrimmedNonEmptyString,
  url: TrimmedNonEmptyString,
});
export type WorkspaceMcpConnectionCreated = typeof WorkspaceMcpConnectionCreated.Type;

export const WorkspaceMcpConnectionRequest = Schema.Union([
  Schema.Struct({
    action: Schema.Literal("create"),
    projectId: OperatorProjectId,
    label: Schema.optionalKey(Schema.String.check(Schema.isMaxLength(128))),
    scopes: Schema.optionalKey(Schema.Array(WorkspaceMcpScope)),
  }),
  Schema.Struct({ action: Schema.Literal("list") }),
  Schema.Struct({ action: Schema.Literal("revoke"), id: TrimmedNonEmptyString }),
]);
export type WorkspaceMcpConnectionRequest = typeof WorkspaceMcpConnectionRequest.Type;

export const WorkspaceMcpOperation = Schema.Struct({
  requestId: TrimmedNonEmptyString.check(Schema.isMaxLength(128)),
  status: Schema.Literals(["running", "completed", "failed", "uncertain"]),
  result: Schema.Unknown,
  requests: Schema.Array(Schema.Unknown),
});
export type WorkspaceMcpOperation = typeof WorkspaceMcpOperation.Type;
